// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"bddd1d69","716":"7766e85f"}[chunkId] + ".chunk.js";
};